import GroupPage from "./GroupPage";
import { IMAGES } from "@/data/content";

export default function Tribes() {
  return (
    <GroupPage
      path="tribes"
      sectionKey="tribes"
      defaultImage={IMAGES.ridge}
      title="Native Tribes"
      overline="The first people of the frontier"
      sub="The tribes of Aurora Springs carry the oldest stories of this land. Learn their names, their ways and their place in the world."
      emptyText="No tribes listed yet — add them from the admin panel."
    />
  );
}
